//@flow
import type {COLOR} from './types'
import { capitalize } from "../capitalize";

/***
 * @description Verify if color is valid
 * @param color The color variable
 * @return {string|null} capitalized name of color OR null
 * @see {@link https://gapinc.atlassian.net/browse/SEO-1572|SEO-1572}
 */
 const getColorName = (color?: COLOR): string | null => (color ? capitalize(color.name) : null);
 export { getColorName }
